import axiosInstance from "../axiosInstance";

// const base = `${process.env.REACT_APP_API_URL || "http://localhost:3001/api"}`;
// const BASE_URL = `${base}/user_roles`;

const BASE_URL = "/settings/user_roles";

/**
 * 📌 Lấy danh sách phân quyền nhân viên
 */
export const getUserRoles = async (params = {}) => {
    try {
      const cleaned = Object.fromEntries(
        Object.entries(params).filter(
          ([, v]) => v !== undefined && v !== null && String(v).trim() !== ""
        )
      );
      const query = new URLSearchParams(cleaned).toString();
      const response = await axiosInstance.get(
        query ? `${BASE_URL}?${query}` : BASE_URL
      );
      return response.data;
    } catch (error) {
      console.error("Lỗi khi lấy danh sách phân quyền:", error);
      throw error;
    }
};
  
/**
 * 📌 Tạo mới phân quyền cho nhân viên
 */
export const createUserRole = async (data) => {
    try {
      const response = await axiosInstance.post(BASE_URL, data);
      return response.data;
    } catch (error) {
      console.error("Lỗi khi tạo phân quyền:", error);
      throw error;
    }
};
  
/**
 * 📌 Cập nhật phân quyền nhân viên
 */
export const updateUserRole = async (_id, data) => {
    try {
      // BE route hiện tại: PUT /settings/user_roles (không có :id)
      const response = await axiosInstance.put(BASE_URL, data);
      return response.data;
    } catch (error) {
      console.error("Lỗi khi cập nhật phân quyền:", error);
      throw error;
    }
};

/**
 * 📌 Xóa phân quyền nhân viên
 */
export const deleteUserRole = async (employee_id, role_id) => {
  try {
    const response = await axiosInstance.delete(BASE_URL, {
      data: { employee_id, role_id },
    });
    return response.data;
  } catch (error) {
    console.error("Lỗi khi xóa phân quyền:", error);
    throw error;
  }
};

export const getUserDataScopes = async (employeeId) => {
  const response = await axiosInstance.get(`${BASE_URL}/${employeeId}/data-scopes`);
  return response.data;
};

export const updateUserDataScopes = async (employeeId, scopes) => {
  const response = await axiosInstance.put(`${BASE_URL}/${employeeId}/data-scopes`, {
    scopes,
  });
  return response.data;
};